import moment from 'app/modules/datetime';
import lang from 'app/lib/moment/lang/it';

moment.lang('it', lang);



// WEBPACK FOOTER //
// ./src/web/js/app/datetime.it.js